export default {
  UNDER_27: 'U27',
  REGULAR: 'REGULAR'
}
